import { render, staticRenderFns } from "./partyInvitation.vue?vue&type=template&id=3b174a51"
import script from "./partyInvitation.vue?vue&type=script&lang=js"
export * from "./partyInvitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports